import { Component, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-form-modal',
    templateUrl: './form-modal.component.html',
    styleUrl: './form-modal.component.css',
    standalone: false
})
export class FormModalComponent implements OnInit{

  message:any = {};
  constructor(private modalService:NgbModal,public activeModal: NgbActiveModal) {

  }

  ngOnInit(): void {
    
  }

  open(content:any) {
    console.log("SSSSSSSS");
    
    this.modalService.open(this.message, {size:'lg',backdrop: 'static'}).result.then(
      (result) => {
        console.log(this.message);
        
      },
      (reason)=> {
        console.log(reason);
      }
    )
  }
}
